<ng-container *transloco="let t">
    <!-- Button -->
    <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative">
            <img class="w-7 h-7 rounded-full" crossorigin="anonymous" *ngIf="showAvatar && user.avatar" [src]="avatarPath + user.avatar" alt="Avatar">
            <mat-icon *ngIf="!showAvatar || !user.avatar" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"></span>
        </span>
    </button>
    <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item>
            <span class="flex flex-col leading-none">
                <span *ngIf="false">{{ t('user.singed_in_as') }}</span>
                <span class="mt-1.5 text-md font-medium">{{user.name}}</span>
            </span>
        </button>
        <mat-divider class="my-2"></mat-divider>
        <button mat-menu-item (click)="openChangePassword()">
            <mat-icon [svgIcon]="'heroicons_outline:key'"></mat-icon>
            <span>{{ t('user.change_password.menu') }}</span>
        </button>
        <button mat-menu-item (click)="signOut()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
            <span>{{ t('user.sign_out') }}</span>
        </button>
    </mat-menu>
</ng-container>
